'use strict';

module.exports = /*@ngInject*/ ['rx', 'TrainService', function TrainTypeConfigurationService(rx, TrainService) {

  var serviceAPI = {
    getTrainTypeConfiguration: getTrainTypeConfiguration
  };
  
  var pollingPeriod = 60000; // TODO put in a global configuration file

  function getTrainTypeConfiguration(projectId, trainId) {
    return rx.Observable.timer(0, pollingPeriod).switchMap(function () {
        return rx.Observable.fromPromise(TrainService.getTypeConfiguration(projectId).get({
            projectId: projectId,
            trainId: trainId
        }).$promise); 
      });
  }
  return serviceAPI;

}];